import { styled } from 'dripsy';
import React, { Fragment } from 'react';
import { View } from 'react-native';

import { IS_WEB } from '@utils';
import { ScreensNameType } from '@navigation';
import { BreadcrumbBar } from '../views/BreadcrumbBar';
import { ScreenTopBar } from '../views/ScreenTopBar';

const Container = styled(View)({
  flex: 1,
  bg: '$background0',
});

const ContentContainer = styled(View)({
  flex: 1,
  mx: [null, '5%'],
});

const BreadcrumbsContainer = styled(View)({
  px: ['$6', '5%'],
});

export interface IListLayoutProps {
  children: React.ReactNode;
  title: string;
  breadcrumbRoutes?: ScreensNameType[];
  isSearchVisible?: boolean;
}

// TODO: Find a way to fix breadcrumbs
// for More Tutorials and Tracks
export function ListLayout({
  children,
  title,
  breadcrumbRoutes,
  isSearchVisible = false,
}: IListLayoutProps) {
  const withBreadcrumbs = !!breadcrumbRoutes;

  return (
    <Container>
      {IS_WEB && (
        <Fragment>
          {withBreadcrumbs && (
            <BreadcrumbsContainer>
              <BreadcrumbBar routes={breadcrumbRoutes} />
            </BreadcrumbsContainer>
          )}
          <ScreenTopBar
            title={title}
            isSearchVisible={isSearchVisible}
          />
        </Fragment>
      )}

      <ContentContainer>{children}</ContentContainer>
    </Container>
  );
}
